import { RoomStatus } from "@/types/room";
import { z } from "zod";

export const createRoomSchema = z.object({
  number: z.string(),
  categoryId: z.string(),
  status: z.enum(RoomStatus),
  floor: z.string(),
  area: z.string(),
  photoId: z.string().optional(),
});

export const editRoomSchema = createRoomSchema.extend({
  photoId: z.string().nullable().optional(),
});

export type CreateRoomFormData = z.infer<typeof createRoomSchema>;
export type EditRoomFormData = z.infer<typeof editRoomSchema>;
